import { Gtp } from '../shared/gtp';

export class AdminCtrlVehGeocerca {

    public activo: boolean;
    public entrada: boolean;
    public geoid: number;
    public maxparada: number;
    public nombre: string;        
    public salida: boolean;
    public velmax: number;

    constructor(data: any) {
        let gtp = new Gtp();
        this.geoid = data.gid;
        this.nombre = data.nombre;
        this.activo = (data.activo) ? this.activo : false;
        this.entrada = (data.entrada) ? this.entrada : false;
        this.salida = (data.salida) ? this.salida : false;
        this.velmax = (data.velmax) ? this.velmax : 0;
        this.maxparada = (data.maxparada) ? this.maxparada : 0;        
    }

}